import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class ComparisonChart extends HTMLElement {
  constructor() {
    super();

    // bindings

    // privates
    this._node = this;
    this._swiper_el = this._node.querySelector(".swiper");
    this._scrollbar = this._node.querySelector(".swiper-scrollbar");

    // events
    this._swiper = new Swiper(this._swiper_el, {
      a11y: false,
      speed: 100,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      scrollbar: {
        el: this._scrollbar,
        hide: false,
        draggable: false,
        dragSize: 'auto'
      },
      freeMode: {
        enabled: true,
        minimumVelocity: 0.01,
        momentumRatio: 0.75,
        momentumBounceRatio: 0.5,
        momentumVelocityRatio: 0.5
      },
      keyboard: {
        enabled: false
      }
    });
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
  }
}
